'use client';

import Link from 'next/link';
import useTopStyle from '../../utils/useTopStyle';
import resourceDocs from 'data/resourceDocs';

export default function ResourcesPage() {
    const ref = useTopStyle(72);

    return (
        <div className='legal-page'>
            <section
                className='company-hero'
                ref={ref}
            >
                <div className='container'>
                    <h2 className='title'>
                        Cylerian
                        <span className='highlight'> Resources</span>
                    </h2>
                    <p className='text'>
                        Official resources for Cylerian. Select a resource below.
                    </p>
                </div>
            </section>

            <section className='feed resources-grid'>
                <div className='grid'>
                    {resourceDocs.map((doc) => (
                        <section key={doc.slug}>
                            <div className='inner-container' style={{ height: '280px' }}>
                                <p className='author'>
                                    {doc.type === 'casestudy'
                                        ? 'CASE STUDY'
                                        : doc.type === 'whitepaper'
                                            ? 'WHITE PAPER'
                                            : 'DATA SHEET'}
                                </p>
                                <Link href={`/resources/${doc.slug}/`} className='title'>{doc.title}</Link>
                                <p className='summary'>{doc.desc}</p>
                                <div className='read-more'>
                                    <div>
                                        <Link href={`/resources/${doc.slug}/`} className='arrow-link'>View Document</Link>
                                    </div>
                                </div>
                            </div>
                        </section>
                    ))}
                </div>
            </section>
        </div>
    );
}
